import { reactive } from 'vue';

/** 确认框参数 */
export interface ConfirmOptions {
  /** 标题 */
  title: string;
  /** 正文 (可空) */
  message?: string;
  /** 确认按钮文字, 默认 "确定" */
  confirmText?: string;
  /** 取消按钮文字, 默认 "取消" */
  cancelText?: string;
  /** 危险操作: 确认按钮显示为红色 */
  danger?: boolean;
}

/** 当前确认框状态 (模块级单例, 由 AppConfirm 渲染) */
export const confirmState = reactive<{ open: boolean; options: ConfirmOptions }>({
  open: false,
  options: { title: '' },
});

let resolver: ((ok: boolean) => void) | null = null;

/** 关闭确认框并返回结果 */
export function settleConfirm(ok: boolean) {
  confirmState.open = false;
  const r = resolver;
  resolver = null;
  r?.(ok);
}

/** 弹出确认框, 用户确认返回 true, 取消/关闭返回 false */
export function confirmDialog(options: ConfirmOptions): Promise<boolean> {
  if (resolver) settleConfirm(false);
  confirmState.options = options;
  confirmState.open = true;
  return new Promise<boolean>((resolve) => { resolver = resolve; });
}

/** 全局确认框: 不传参返回弹框函数; 传参直接弹出并返回用户选择 */
export function useConfirm(): typeof confirmDialog;
export function useConfirm(options: ConfirmOptions): Promise<boolean>;
export function useConfirm(options?: ConfirmOptions): typeof confirmDialog | Promise<boolean> {
  return options ? confirmDialog(options) : confirmDialog;
}
